'use strict';

const primusmoney_currency_wallet_load = async () => {
	try {
		// shim
		if (window && !window.Buffer)
		window.Buffer = require('buffer').Buffer;

		let Client_Wallet = require('@primusmoney/client_wallet');
		let client_wallet = Client_Wallet.getObject();

		let client_wallet_init = await client_wallet.init();

		// currencies module
		const Currencies = require('@primusmoney/currencies');
		let currencies = Currencies.getObject();

		let currencies_init = await currencies.init();

		// adding also @p2pmoney-org/ethereum_erc721
		const Ethereum_erc721 = require('@p2pmoney-org/ethereum_erc721');
		let ethereum_erc721 = Ethereum_erc721.getObject();

		let ethereum_erc721_init = await ethereum_erc721.init();

		// put Client_Wallet && Currencies in stored objects
		let client_global = client_wallet.getGlobalObject();

		client_global.putGlobalStoredObject('PrimusMoney_Client_Wallet', Client_Wallet);
		client_global.putGlobalStoredObject('PrimusMoney_Currencies', Currencies);
		client_global.putGlobalStoredObject('Ethereum_erc721', Ethereum_erc721);

		// and other dependent packages
		client_global.putGlobalStoredObject('Ethereum_core', require('@p2pmoney-org/ethereum_core'));
		client_global.putGlobalStoredObject('Ethereum_erc20', require('@p2pmoney-org/ethereum_erc20'));
		client_global.putGlobalStoredObject('Ethereum_xtra_web', require('@p2pmoney-org/ethereum_xtra_web'));

		client_global.putGlobalStoredObject('PrimusMoney_Ethereum_xtra_web', require('@primusmoney/ethereum_xtra_web'));

		// TODO: remove when controllers integrated into @p2pmoney-org/ethereum_core
		// put controllers class in common module
		let GlobalClass = window.simplestore.Global;
		let CoreAPIControllers = require('./@p2pmoney_ethereum_core/controller/controllers');

		GlobalClass.registerModuleClass('common', 'CoreAPIControllers', CoreAPIControllers);



		return (client_wallet_init && currencies_init);
	}
	catch(e) {
		console.log('exception in primusmoney_currency_wallet_load: ' + e);
	}
}

primusmoney_currency_wallet_load()
.then( () => {
	console.log('@primusmoney_currency_wallet loaded');

	// signal end of load
	let ScriptLoader = (window && window.simplestore && window.simplestore.ScriptLoader ? window.simplestore.ScriptLoader : null);

	if (ScriptLoader) {
		var rootscriptloader = ScriptLoader.getRootScriptLoader();
	
		rootscriptloader.signalEvent('on_primusmoney_currency_wallet_load_end');
	}
})
.catch(err => {});
